import { useQuery } from '@tanstack/react-query';
import { getUserManagementOverview, UserManagementOverviewResponse } from 'api/userCredentials';

export const userManagementOverviewQueryKey = ['userManagementOverview'] as const;

export const useUserManagementOverview = (labId: string, enabled = true) => {
  return useQuery<UserManagementOverviewResponse>(
    [...userManagementOverviewQueryKey, labId],
    () => getUserManagementOverview(labId),
    {
      enabled: Boolean(labId) && enabled,
      refetchOnWindowFocus: false,
      staleTime: 60_000,
    }
  );
};
